export default "__VITE_ASSET__0ef03f5d__"